<template>
    <div>
        <form @submit.prevent="update">
            <text-input
                v-model="editedBodyText"
                label="Uppgift"
                name="body"
                :autofocus="true"
            />
        </form>

        <form class="my-md" @submit.prevent="addOption">
            <div class="flex items-center">
                <text-input
                    v-model="newOption"
                    label="Nytt val"
                    name="new_option"
                    class="flex-grow mr-lg mb-0"
                />

                <button
                    type="button"
                    class="ml-auto btn btn-md is-primary"
                    @click="addOption"
                >
                    Lägg till val
                </button>
            </div>
        </form>

        <h4 class="headline-md">
            Val:
        </h4>

        <ul class="list-reset">
            <li v-for="(option, key) in editedOptions" :key="key">
                <font-awesome-icon
                    :icon="['fal', 'times']"
                    class="text-danger cursor-pointer"
                    @click="removeOption(option)"
                />
                {{ option }}
            </li>
        </ul>

        <base-actions
            @update="update"
            @delete="deleteTask"
            @cancel="$emit('cancel', true)"
        />
    </div>
</template>
<script>
    import BaseEditComponent from './BaseEditComponent';
    import BaseActions from './BaseActions';

    export default {
        components: {
            BaseActions,
        },
        extends: BaseEditComponent,
        data() {
            return {
                editing: false,
                editedBodyText: this.task.body,
                editedOptions: this.task.data.options,
                newOption: '',
            };
        },
        computed: {
            extraData() {
                return {
                    options: this.editedOptions,
                };
            },
        },
        methods: {
            addOption() {
                this.editedOptions[this.newOption] = this.newOption;
                this.newOption = '';
            },
            removeOption(option) {
                Vue.delete(this.editedOptions, option);
            },
        },
    };
</script>